import React from 'react';

export const ParamsContext = React.createContext();
